var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9564 11H5.53971C4.48117 11 3.62305 11.8954 3.62305 13V20C3.62305 21.1046 4.48117 22 5.53971 22H18.9564C20.0149 22 20.873 21.1046 20.873 20V13C20.873 11.8954 20.0149 11 18.9564 11Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45605 11V7C7.45605 5.67392 7.96089 4.40215 8.8595 3.46447C9.75811 2.52678 10.9769 2 12.2477 2C13.5186 2 14.7373 2.52678 15.6359 3.46447C16.5346 4.40215 17.0394 5.67392 17.0394 7V11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b41700c230a0a156337eeae8f5848426.svg";
export { ForwardRef as ReactComponent };